export default __webpack_public_path__ + "static/botella_2-56f0fbff5cb217a0e7c33392fe1ee340.jpg";